// extracted by mini-css-extract-plugin
export default {"overlayContainer":"NoteFinderPageOverlayTie_overlayContainer__zHAs7"};